<div mat-dialog-title>
  <div class="flex items-center justify-between h-48">
    <h6>Edit {{ data.ownerName }}</h6>
    <button matIconButton aria-label="Close" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-divider class="mx-20!" />
<div mat-dialog-content class="add-user-container">
  <form [formGroup]="contactForm" class="grid grid-cols-4 gap-x-20">
    <mat-form-field class="col-span-full">
      <mat-label>Email</mat-label>
      <input formControlName="email" matInput [(ngModel)]="data.ownerEmail" />
      @if (email.hasError('pattern') || email.invalid) {
        <mat-error class="mat-error"> Please enter a valid email address </mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Home</mat-label>
      <input formControlName="homePhone" matInput [(ngModel)]="data.ownerHomePhone" />
      @if (homePhone.touched && homePhone.hasError('phoneInvalid')) {
        <mat-error class="mat-error"> {{ getErrorMessage(homePhone.errors) }} </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Mobile</mat-label>
      <input formControlName="mobilePhone" matInput [(ngModel)]="data.ownerMobilePhone" />
      @if (mobilePhone.touched && mobilePhone.hasError('phoneInvalid')) {
        <mat-error class="mat-error"> {{ getErrorMessage(mobilePhone.errors) }} </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Work</mat-label>
      <input formControlName="workPhone" matInput [(ngModel)]="data.ownerWorkPhone" />
      @if (workPhone.touched && workPhone.hasError('phoneInvalid')) {
        <mat-error class="mat-error"> {{ getErrorMessage(workPhone.errors) }} </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Postcode</mat-label>
      <input formControlName="postCode" matInput [(ngModel)]="data.ownerPostCode" />
    </mat-form-field>
  </form>
</div>
<mat-divider class="mx-20!" />
<mat-dialog-actions>
  <button matButton="elevated" class="charcoal-button" mat-dialog-close>CANCEL</button>
  <button
    matButton="elevated"
    class="red-button"
    type="submit"
    (click)="saveContact()"
    [disabled]="contactForm.invalid || contactForm.pristine || pending()">
    SAVE
  </button>
</mat-dialog-actions>
